import React from 'react';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import FAQSection from '../components/FAQSection';
import TestimonialsSection from '../components/TestimonialsSection';
import SessionRequestForm from '../components/SessionRequestForm';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ShieldCheck, Lock } from 'lucide-react';
import usePageMeta from '../hooks/usePageMeta';

const PrinciplesSection = () => {
  const items = [
    {
      icon: ShieldCheck,
      title: 'Safe & Consensual',
      text: 'Every session is founded on trust, consent, and clear communication. Your safety is paramount.',
    },
    {
      icon: Lock,
      title: 'Absolute Discretion',
      text: 'All conversations and sessions are handled with complete confidentiality.',
    },
  ];
  return (
    <section className="bg-neutral-50 border-y border-neutral-200">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-10">
        {items.map(({ icon: Icon, title, text }) => (
          <div key={title} className="text-center md:text-left">
            <Icon size={32} className="text-neutral-900 mx-auto md:mx-0 mb-4" strokeWidth={1.5} />
            <h3 className="font-serif text-2xl text-neutral-900 mb-2">{title}</h3>
            <p className="text-neutral-600 text-sm leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

const IntroSection = () => (
  <section className="bg-white">
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24 md:py-32 text-center">
      <p className="text-neutral-500 text-xs uppercase tracking-[0.35em] mb-6">RealOTK.com</p>
      <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-neutral-900 font-bold tracking-tight leading-[1.1]">
        Accountability Through Consequences
      </h2>
      <div className="mt-8 mx-auto w-16 h-px bg-neutral-900" />
      <p className="mt-10 text-lg md:text-xl text-neutral-700 leading-relaxed">
        Seattle&rsquo;s professional spanking disciplinarian offering authentic <strong>OTK (over-the-knee)</strong>{' '}
        spankings, <strong>paddling</strong>, <strong>whipping</strong>, caning, hairbrush and belt discipline
        to motivate personal growth and hold clients accountable. Serving Seattle, Tacoma, Everett, Bellevue
        and greater Western Washington — real spankings for real reasons, in a safe, controlled, and
        completely confidential environment.
      </p>
    </div>
  </section>
);

const CTASection = () => (
  <section
    className="relative py-32 bg-cover bg-center bg-fixed"
    style={{
      backgroundImage:
        "url('https://images.unsplash.com/photo-1613491291185-eab390ed50eb?ixid=M3wzOTE5Mjl8MHwxfHNlYXJjaHwzfHxpbXByb3ZlbWVudHxlbnwwfHx8fDE3MTMyODkxMjN8MA&ixlib=rb-4.0.3&auto=format&fit=crop&w=3840')",
    }}
  >
    <div className="absolute inset-0 bg-black/60" />
    <div className="relative max-w-3xl mx-auto text-center px-6">
      <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-bold tracking-tight leading-tight">
        Ready to be held accountable?
      </h2>
      <p className="mt-6 text-white/85 text-lg">
        First sessions are always free so you can determine if we’re a good fit.
      </p>
      <div className="mt-10">
        <Link to="/session-request">
          <Button className="rounded-none bg-white text-neutral-900 hover:bg-neutral-100 h-12 px-10 text-sm tracking-widest uppercase">
            Request a Session
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

const Home = () => {
  usePageMeta({
    title: 'Seattle Spanking & OTK Disciplinarian — Real Spankings for Real Reasons',
    description: 'Seattle professional spanking disciplinarian offering real OTK (over-the-knee) spankings, paddling, whipping, hairbrush, belt, and cane discipline. Serving Seattle, Tacoma, Everett, Bellevue and Western Washington. Safe, consensual, confidential. First session free.',
    path: '/',
  });
  return (
  <div>
    <Hero />
    <IntroSection />
    <PrinciplesSection />
    <ServicesSection />
    <TestimonialsSection />
    <FAQSection />
    <CTASection />
    <section className="bg-neutral-50">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-24">
        <SessionRequestForm />
      </div>
    </section>
  </div>
  );
};

export default Home;
